// Canonical Southern African areas for travel-notification matching.
// Hierarchical: Province -> Towns. Towns sorted alphabetically inside each province.
// Codes are STABLE — changing them means migrating cardholder data. Add freely, rename rarely.

export const AREAS_BY_PROVINCE = {
  "Eastern Cape": [
    { code: "BUTTERWORTH",  label: "Butterworth" },
    { code: "EAST_LONDON",  label: "East London" },
    { code: "ENGCOBO",      label: "Engcobo" },
    { code: "FLAGSTAFF",    label: "Flagstaff" },
    { code: "GQEBERHA",     label: "Gqeberha (PE)" },
    { code: "KING_W_TOWN",  label: "King William's Town" },
    { code: "LUSIKISIKI",   label: "Lusikisiki" },
    { code: "MTHATHA",      label: "Mthatha" },
    { code: "PORT_ALFRED",  label: "Port Alfred" },
    { code: "QUEENSTOWN",   label: "Queenstown" },
    { code: "UITENHAGE",    label: "Uitenhage / Kariega" },
  ],
  "Free State": [
    { code: "BETHLEHEM",    label: "Bethlehem" },
    { code: "BLOEMFONTEIN", label: "Bloemfontein" },
    { code: "WELKOM",       label: "Welkom" },
  ],
  "Gauteng": [
    { code: "GERMISTON",    label: "Germiston" },
    { code: "JHB_CBD",      label: "Johannesburg CBD" },
    { code: "PRETORIA",     label: "Pretoria" },
    { code: "SOWETO",       label: "Soweto" },
    { code: "TEMBISA",      label: "Tembisa" },
  ],
  "KwaZulu-Natal": [
    { code: "DURBAN",       label: "Durban" },
    { code: "EMPANGENI",    label: "Empangeni" },
    { code: "NEWCASTLE",    label: "Newcastle" },
    { code: "PMB",          label: "Pietermaritzburg" },
    { code: "RICHARDS_BAY", label: "Richards Bay" },
  ],
  "Limpopo": [
    { code: "MUSINA",       label: "Musina" },
    { code: "POLOKWANE",    label: "Polokwane" },
    { code: "TZANEEN",      label: "Tzaneen" },
  ],
  "Mpumalanga": [
    { code: "WITBANK",      label: "eMalahleni (Witbank)" },
    { code: "NELSPRUIT",    label: "Mbombela (Nelspruit)" },
  ],
  "North West": [
    { code: "MAFIKENG",     label: "Mahikeng" },
    { code: "RUSTENBURG",   label: "Rustenburg" },
  ],
  "Northern Cape": [
    { code: "KIMBERLEY",    label: "Kimberley" },
  ],
  "Western Cape": [
    { code: "BELLVILLE",    label: "Bellville" },
    { code: "CT_CBD",       label: "Cape Town CBD" },
    { code: "GEORGE",       label: "George" },
    { code: "GUGULETHU",    label: "Gugulethu" },
    { code: "KHAYELITSHA",  label: "Khayelitsha" },
    { code: "MITCHELLS",    label: "Mitchells Plain" },
    { code: "MOSSEL_BAY",   label: "Mossel Bay" },
    { code: "PAARL",        label: "Paarl" },
    { code: "SOMERSET_W",   label: "Somerset West" },
    { code: "STRAND",       label: "Strand" },
    { code: "WORCESTER",    label: "Worcester" },
  ],
  // Cross-border destinations grouped under each country
  "Botswana": [
    { code: "GABORONE",     label: "Gaborone" },
  ],
  "Eswatini": [
    { code: "MBABANE",      label: "Mbabane" },
  ],
  "Lesotho": [
    { code: "MASERU",       label: "Maseru" },
  ],
  "Malawi": [
    { code: "BLANTYRE",     label: "Blantyre" },
  ],
  "Mozambique": [
    { code: "MAPUTO",       label: "Maputo" },
  ],
  "Zambia": [
    { code: "LUSAKA",       label: "Lusaka" },
  ],
  "Zimbabwe": [
    { code: "BULAWAYO",     label: "Bulawayo" },
    { code: "HARARE",       label: "Harare" },
  ],
};

// Provinces in display order: 9 SA provinces alphabetical, then cross-border alphabetical.
export const SA_PROVINCES = [
  "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal",
  "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape",
];
export const CROSS_BORDER = [
  "Botswana", "Eswatini", "Lesotho", "Malawi", "Mozambique", "Zambia", "Zimbabwe",
];
export const ALL_PROVINCES = [...SA_PROVINCES, ...CROSS_BORDER];

// Flat array kept for legacy callers & label lookup.
export const SA_AREAS = ALL_PROVINCES.flatMap((p) =>
  AREAS_BY_PROVINCE[p].map((a) => ({ ...a, province: p }))
);

export const labelForArea = (code) => {
  const a = SA_AREAS.find((x) => x.code === code);
  return a ? a.label : code;
};

export const provinceForArea = (code) => {
  const a = SA_AREAS.find((x) => x.code === code);
  return a ? a.province : null;
};
